'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Grid = require('./Grid');

var _Grid2 = _interopRequireDefault(_Grid);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class(props) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      page: props.pagination.page,
      query: props.query
    };
    return _this;
  }

  _createClass(_class, [{
    key: 'getColumns',
    value: function getColumns() {
      return [{
        key: 'title',
        title: 'Form',
        sort: true
      }, {
        key: 'operations',
        title: 'Operations',
        sort: false
      }];
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$forms = _props.forms,
          forms = _props$forms.forms,
          limit = _props$forms.limit,
          pagination = _props$forms.pagination,
          onAction = _props.onAction,
          formAccess = _props.formAccess,
          perms = _props.perms;
      var columns = this.getColumns();
      var columnWidths = {
        0: 8,
        1: 4
      };
      var skip = (parseInt(this.state.page) - 1) * parseInt(limit);
      var last = skip + parseInt(limit) > pagination.total ? pagination.total : skip + parseInt(limit);
      var sortOrder = this.state.query.sort;
      return _react2.default.createElement(_Grid2.default, {
        items: forms,
        columns: columns,
        columnWidths: columnWidths,
        onAction: onAction,
        onSort: this.onSort,
        onPage: this.onPage,
        sortOrder: sortOrder,
        activePage: pagination.page,
        firstItem: skip + 1,
        lastItem: last,
        total: parseInt(pagination.total),
        pages: Math.ceil(parseInt(pagination.total) / limit),
        emptyText: 'No forms found',
        Cell: this.Cell,
        formAccess: formAccess,
        perms: perms
      });
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.query !== prevState.query) {
        return {
          query: nextProps.query
        };
      }

      return null;
    }
  }]);

  return _class;
}(_react.Component);

_class.propTypes = {
  forms: _propTypes2.default.object,
  perms: _propTypes2.default.object,
  getForms: _propTypes2.default.func,
  query: _propTypes2.default.object,
  onAction: _propTypes2.default.func,
  formAccess: _propTypes2.default.func
};
_class.defaultProps = {
  perms: {
    view: true,
    edit: true,
    data: true,
    delete: true
  },
  pagination: {
    page: 1,
    numPages: 1,
    total: 1
  },
  getForms: function getForms() {},
  query: {
    sort: ''
  },
  formAccess: function formAccess() {
    return {
      form: {
        create: true,
        view: true,
        edit: true,
        delete: true
      },
      submission: {
        create: true,
        view: true,
        edit: true,
        delete: true
      }
    };
  }
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onPage = function (page) {
    _this2.setState(function (prevState) {
      prevState.page = page;
      return prevState;
    }, function () {
      return _this2.props.getForms(_this2.state.page, _this2.state.query);
    });
  };

  this.onSort = function (field) {
    if (!_this2.state.query.sort) {
      _this2.setState(function (prevState) {
        prevState.query.sort = field;
        return prevState;
      }, function () {
        return _this2.props.getForms(_this2.state.page, _this2.state.query);
      });
    }

    var currentSort = _this2.state.query.sort[0] === '-' ? _this2.state.query.sort.slice(1, _this2.state.query.sort.length) : _this2.state.query.sort;

    if (currentSort !== field) {
      _this2.setState(function (prevState) {
        prevState.query.sort = field;
        return prevState;
      }, function () {
        return _this2.props.getForms(_this2.state.page, _this2.state.query);
      });
    } else if (_this2.state.query.sort[0] !== '-') {
      _this2.setState(function (prevState) {
        prevState.query.sort = '-' + field;
        return prevState;
      }, function () {
        return _this2.props.getForms(_this2.state.page, _this2.state.query);
      });
    } else {
      _this2.setState(function (prevState) {
        prevState.query.sort = '';
        return prevState;
      }, function () {
        return _this2.props.getForms(_this2.state.page, _this2.state.query);
      });
    }
  };

  this.Cell = function (props) {
    var form = props.row,
        column = props.column,
        formAccess = props.formAccess;
    var access = formAccess(form);

    if (column.key === 'title') {
      return _react2.default.createElement('span', {
        style: {
          cursor: 'pointer'
        },
        onClick: function onClick() {
          if (access.submission.create) {
            props.onAction(form, 'view');
          }
        }
      }, _react2.default.createElement('h5', null, form.title));
    } else {
      return _react2.default.createElement('div', null, access.submission.create ? _react2.default.createElement('span', {
        className: 'btn btn-primary btn-sm form-btn',
        onClick: function onClick() {
          return props.onAction(form, 'view');
        }
      }, _react2.default.createElement('i', {
        className: 'fa fa-pencil'
      }), '\xA0 Enter Data') : null, access.submission.view ? _react2.default.createElement('span', {
        className: 'btn btn-warning btn-sm form-btn',
        onClick: function onClick() {
          return props.onAction(form, 'submission');
        }
      }, _react2.default.createElement('i', {
        className: 'fa fa-list-alt'
      }), '\xA0 View Data') : null, access.form.edit ? _react2.default.createElement('span', {
        className: 'btn btn-secondary btn-sm form-btn',
        onClick: function onClick() {
          return props.onAction(form, 'edit');
        }
      }, _react2.default.createElement('i', {
        className: 'fa fa-edit'
      }), '\xA0 Edit Form') : null, access.form.delete ? _react2.default.createElement('span', {
        className: 'btn btn-danger btn-sm form-btn',
        onClick: function onClick() {
          return props.onAction(form, 'delete');
        }
      }, _react2.default.createElement('i', {
        className: 'fa fa-trash'
      })) : null);
    }
  };
};

exports.default = _class;